import {
  CONFIRMED_CREATE_DEPARTMENT_ACTION,
  CONFIRMED_DELETE_DEPARTMENT_ACTION,
  CONFIRMED_EDIT_DEPARTMENT_ACTION,
  CONFIRMED_GET_DEPARTMENTS,
} from "../actions/DepartmentType";

import {
  createDepartment,
  formatDepartments,
  getDepartments,
  deleteDepartment,
  updateDepartment,
} from "../../services/DepartmentService";

import swal from "sweetalert";
import { handleError, handleSuccess, showErrorAlert } from "../../services/ErrorHandlingService";


function getAuthToken(getState) {
  const stateToken = getState().auth?.authKey;
  if (stateToken) return stateToken;

  const storedUser = localStorage.getItem('userDetails');
  return storedUser ? JSON.parse(storedUser).token : null;
}

// export function getDepartmentsAction(pagination = true, pageid = 0,search_by = "", search_keyword = "",sort_by = "", sort_order = "") {
//   return async (dispatch, getState) => {
//     try {
//       const token = getAuthToken(getState);
//       //console.log("parameter");
//       //console.log(admin_id, pagination, pageid, token);
//       const response = await getDepartments(pagination, pageid,search_by,search_keyword, sort_by, sort_order,token);

//       if (response && response.status === 200 && response.data) {
//         if (response.data.status === "success" && response.data.data) {
//           const departments = formatDepartments(response.data.data);
//           dispatch({ type: CONFIRMED_GET_DEPARTMENTS, payload: departments });
//         } else {
//           handleError("Failed to get departments: Server error");
//         }
//       } else {
//         handleError("Failed to get departments: Network error");
//       }
//     } catch (error) {
//       console.error("API Error:", error.response || error);
//       showErrorAlert("Failed to get departments");
//     }
//   };
// }
export function getDepartmentsAction(
  pagination = true, 
  pageid = 0,
  search_by = "", 
  search_keyword = "",
  sort_by = "", 
  sort_order = ""
) {
  return async (dispatch, getState) => {
    try {
      const token = getAuthToken(getState);
      
      const response = await getDepartments(
        pagination, 
        pageid,
        search_by,
        search_keyword, 
        sort_by, 
        sort_order,
        token
      );
      
      if (response && response.status === 200 && response.data) {
        if (response.data.status === "success" && response.data.data) {
          const departments = formatDepartments(response.data.data);
          const num_rows = response.data.num_rows || 0;
          
          dispatch({ 
            type: CONFIRMED_GET_DEPARTMENTS, 
            payload: { departments, num_rows }
          });
        } else {
          handleError("Failed to get departments: Server error");
        }
      } else {
        handleError("Failed to get departments: Network error");
      }
    } catch (error) {
      console.error("API Error:", error.response || error);
      showErrorAlert("Failed to get departments");
    }
  };
}

export function deleteDepartmentAction(department) {
  return async (dispatch) => {
    try {
      const response = await deleteDepartment(department);
      if (response?.data?.status === "success") {
        dispatch({
          type: CONFIRMED_DELETE_DEPARTMENT_ACTION,
          payload: { department_id: department.department_id }
        });
        handleSuccess("Department deleted successfully!");
      } else {
        showErrorAlert(response?.data?.message || "Failed to delete department");
      }
    } catch (error) {
      console.error(error);
      showErrorAlert(error.response?.data?.message || "Failed to delete department");
    }
  };
}

export function createDepartmentAction(departmentData, navigate, returnTo) {
  return async (dispatch) => {
    try {
      const newDepartment = {
        department_name: departmentData.department_name,
        department_description: departmentData.department_description,
        department_status: departmentData.department_status,
        branches: departmentData.branches || "",
      };

      const response = await createDepartment(newDepartment);

      if (response?.data?.status === "success") {
        dispatch({
          type: CONFIRMED_CREATE_DEPARTMENT_ACTION,
          payload: newDepartment
        });

        handleSuccess("Department created successfully!");

        navigate("/departments", {
          state: returnTo ? { ...returnTo } : undefined,
        });
      } else {
        showErrorAlert(response?.data?.message || "Failed to create department");
      }
    } catch (error) {
      console.error("Create Department Error:", error);
      showErrorAlert(error.response?.data?.message || "Failed to create department");
    }
  };
}


export function updateDepartmentAction(departmentData, departmentId, navigate, returnTo) {
  return async (dispatch) => {
    try {
      const payload = {
        ...departmentData,
        department_id: departmentId,
      };

      const response = await updateDepartment(payload);

      if (response?.data?.status === "success") {
        const updatedDepartment = {
          ...response.data.data,
          branches: response.data.data.branches || [],
        };

        dispatch({
          type: CONFIRMED_EDIT_DEPARTMENT_ACTION,
          payload: updatedDepartment,
        });

        handleSuccess("Department updated successfully!", "success");

        navigate("/departments", {
          state: returnTo ? { ...returnTo } : undefined,
        });

      } else {
        showErrorAlert(response?.data?.message || "Failed to update department");
      }
    } catch (error) {
      console.error("Update Department Error:", error);
      showErrorAlert(error.response?.data?.message || "Failed to update department");
    }
  };
}

